import Recat, { forwardRef, useEffect, useRef, useState } from 'react'
import { Spin, Table } from 'antd'
import { SGeneralForms } from 'shj-components'
import { transferFindDetailResponseByRequest } from '@/services/fmsServices'
export const TransFerForm = Recat.forwardRef((props: any,) => {
  const { editData } = props
  const formRef: any = useRef()
  const [spinning, setSpinning] = useState(false)
  const [collectList, setCollectList] = useState([] as any[]);
  useEffect(() => {
    initFn()
  }, [])
  const initFn = async () => {
    if(editData?.id){
      setSpinning(true)
      transferFindDetailResponseByRequest({id: editData?.id}).then((res)=>{
        setSpinning(false)
        formRef.current?.onFormRef()?.setFieldsValue(res)
        setCollectList(res?.transferTransactionList)
      }).catch(err=>{
        setSpinning(false)
      })
    }
  }
  const columns = [
    { title: '收款单号', dataIndex: 'transferOutTransactionCode', width: 160, },
    { title: '支付方式', dataIndex: 'paymentMethodName', width: 120, },
    { title: '收款金额', dataIndex: 'amount', width: 120, },
    { title: '转款金额', dataIndex: 'transferAmount', width: 120, },
    { title: '转出收款单号', dataIndex: 'transferOutNegTransactionCode', width: 160, },
    { title: '转入收款单号', dataIndex: 'transferInTransactionCode', width: 160, },
  ];
  return (
    <Spin spinning={spinning}>
      <SGeneralForms
        ref={formRef}
        isDetail={true}
        isFooterBtn={false}
        configs={[
          {
            formItem: [
              { label: 'id', name: 'id', hidden: true },
              {
                label: '转款单号',
                name: 'billNo',
                spanCol: 8,
              },
              {
                label: '转款时间',
                name: 'createdTime',
                type: 'dateTime',
                spanCol: 8,
              },
              {
                label: '转出交易类型',
                name: 'transferOutTransactionTypeName',
                spanCol: 8,
              },
              {
                label: '转出订单号',
                name: 'orderNo',
                spanCol: 8,
              },
              {
                label: '订单可转余额',
                name: 'canRefundAmount',
                spanCol: 8,
              },
              {
                label: '转出类型',
                name: 'transferTypeName',
                spanCol: 8,
              },
              {
                label: '转入交易类型',
                name: 'transferInTransactionTypeName',
                spanCol: 8,
              
              },
              {
                label: '转入订单号',
                name: 'transferInOrderNo',
                spanCol: 8,
              },
              {
                label: '原因说明',
                type: 'textarea',
                name: 'transferReason',
                spanCol: 24,
              },
            ],
          },
          //按订单余额转出
          {
            title: '订单可转余额明细',
            formItem: [
              {
                name: 'receivedList',
                spanCol: 24,
                children: (
                  <Table
                    bordered
                    pagination={false}
                    columns={columns}
                    size="small"
                    dataSource={collectList} />
                )
              }
            ]
          }
        ]}
      />
    </Spin>
  )
})
